import { whatIfInnerSelector, whatIfOptionsOrDefaultSelector } from '../../WhatIfsSelector';
import { FIELD_MAP } from './PriceChangesView';

export const dynamicFieldSelector = (state, props) => {
  const whatIfInner = whatIfInnerSelector(state, props);
  const whatIfType = props.whatIfTemplate?.WhatIfType;
  const fieldName = FIELD_MAP[whatIfType];
  return whatIfInner?.[fieldName] ?? 0;
};

export const givingStrategySelector = (state, props) => {
  const whatIfOptions = whatIfOptionsOrDefaultSelector(state, props);
  return whatIfOptions.givingStrategy;
};

export default null;
